import { jsx as _jsx } from "react/jsx-runtime";
import { EditPaymentRequest } from '@src/components/Employee/PaymentRequests/EditPaymentRequest/EditPaymentRequest';
import { ProgramContextProvider } from '@src/contexts/ProgramContextProvider';
import { usePrograms } from '@src/hooks/usePrograms';
import { PaymentRequestStatus } from '@src/types';
export const NewRequest = ({ programId }) => {
    const { find } = usePrograms();
    const program = find(programId);
    const paymentRequest = {
        id: 0,
        clientId: program?.clientId || 0,
        programId: program?.id || 0,
        documents: { docs: [] },
        status: PaymentRequestStatus.IN_REVIEW,
        paymentRequestItems: [],
        requestNum: '',
        capYear: 0,
        termStartDate: '',
        termEndDate: '',
        extraData: {},
    };
    if (!program)
        return null;
    return (_jsx(ProgramContextProvider, { program: program, children: _jsx(EditPaymentRequest, { program: program, paymentRequest: paymentRequest }) }));
};
